var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 6.99966C4.33941 7 4.29948 7 4.25388 7H2.19884C1.77962 7 1.5697 7 1.40943 6.91832C1.2683 6.84644 1.15365 6.73157 1.08175 6.59046C1 6.43004 1 6.22011 1 5.80007V2.20008C1 1.78003 1 1.56986 1.08175 1.40943C1.15365 1.2683 1.2683 1.15365 1.40943 1.08175C1.56986 1 1.78003 1 2.20008 1H5.80007C6.22011 1 6.42985 1 6.59028 1.08175C6.73139 1.15365 6.84644 1.2683 6.91832 1.40943C7 1.5697 7 1.77962 7 2.19884V4.25301C7 4.29899 7 4.33919 6.99966 4.375M4.375 6.99966C4.48214 6.99872 4.54986 6.99482 4.61455 6.9793C4.69109 6.96092 4.76421 6.93051 4.8313 6.88938C4.90697 6.84303 4.97185 6.77834 5.10156 6.64862L6.64862 5.10156C6.77834 4.97185 6.84284 4.90697 6.88922 4.8313C6.93032 4.76421 6.96074 4.6909 6.97911 4.6144C6.99464 4.54971 6.99865 4.48206 6.99966 4.375M4.375 6.99966V4.97504C4.375 4.765 4.375 4.65993 4.41588 4.57971C4.45184 4.50914 4.50914 4.45184 4.57971 4.41588C4.65993 4.375 4.76485 4.375 4.97485 4.375H6.99966",
    stroke: "#596675",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/note-icon.36b5967d324e1e5713460ab32ae2231c.svg";
export { ForwardRef as ReactComponent };